<template>

  <li class="list-group-item connection-item">
    <div class="d-flex align-items-center">
      <div class="connection-logo mr-3">
        <img
          v-if="integration.logo"
          :src="integration.logo"
          :alt="title">
        <div
          v-else
          class="connection-logo-fallback">{{ initials }}</div>
      </div>
      <div class="flex-grow-1">
        <div class="d-flex align-items-center">
          <h6 class="mb-0 mr-2">{{ title }}</h6>
          <span
            v-if="statusLabel"
            class="badge"
            :class="active ? 'badge-success' : 'badge-secondary'">{{ statusLabel }}</span>
        </div>
        <p
          v-if="subtitle"
          class="subtext mb-0 mt-1">{{ subtitle }}</p>
      </div>
      <div class="ml-3">
        <button
          v-if="configureRoute"
          type="button"
          class="btn btn-outline-primary"
          @click="configure()">
          {{ $t('Configure') }}
        </button>
      </div>
    </div>
  </li>

</template>

<script>
export default {
  name: 'ConnectionItem',
  props: {
    connection: {
      type: Object,
      required: true
    }
  },
  computed: {
    id () {
      return this.connection._id
    },
    // descritor da integração da conexão
    integration () {
      const integrations = this.$store.getters.getIntegrationProviders || []
      return integrations.find((item) => {
        return item.integration === this.connection.integration
      }) || {}
    },
    // título: nome da integração (ex.: Indeed)
    title () {
      return this.integration.label || this.connection.integration || ''
    },
    // subtítulo: o dado da conexão (ex.: email, nome da conta do whatsapp)
    subtitle () {
      const name = this.connection.name || this.connection.provider_unique_id
      if (!name) return this.connection.status_detail || null

      // o backend às vezes já devolve o nome prefixado com a integração
      const prefix = this.title + ' - '
      return name.indexOf(prefix) === 0 ? name.slice(prefix.length) : name
    },
    active () {
      return this.connection.status === 'active'
    },
    statusLabel () {
      if (!this.connection.status) return null
      return this.active ? this.$t('Active') : this.$t('Inactive')
    },
    initials () {
      return (this.title || '?').trim().charAt(0).toUpperCase()
    },
    configureRoute () {
      if (!this.id) return null
      return { name: 'config.connection', params: { id: this.id } }
    }
  },
  methods: {
    configure () {
      if (this.configureRoute) this.$router.push(this.configureRoute)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .connection-item {
    display: block;
  }
  .connection-logo {
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .connection-logo img {
    max-width: 100%;
    max-height: 100%;
  }
  .connection-logo-fallback {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/Integrations/ConnectionItem.vue